import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UploadingDoc = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="uploading document icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M16.5607 1.31802C17.4046 0.474104 18.5492 0 19.7426 0H43.5C45.9853 0 48 2.01472 48 4.5V39.5H45V4.5C45 3.67157 44.3284 3 43.5 3H19.7426C19.3448 3 18.9633 3.15803 18.682 3.43934L10.4393 11.682C10.158 11.9633 10 12.3448 10 12.7426V54.5C10 55.3284 10.6716 56 11.5 56H36.5V59H11.5C9.01472 59 7 56.9853 7 54.5V12.7426C7 11.5492 7.47411 10.4046 8.31802 9.56066L16.5607 1.31802Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10V1.5H20V11.5C20 12.3284 19.3284 13 18.5 13H8.5V10H17Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 47.5C15 46.6716 15.6716 46 16.5 46H27C27.8284 46 28.5 46.6716 28.5 47.5C28.5 48.3284 27.8284 49 27 49H16.5C15.6716 49 15 48.3284 15 47.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 40.5C15 39.6716 15.6716 39 16.5 39H27C27.8284 39 28.5 39.6716 28.5 40.5C28.5 41.3284 27.8284 42 27 42H16.5C15.6716 42 15 41.3284 15 40.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 33.5C15 32.6716 15.6716 32 16.5 32H38.5C39.3284 32 40 32.6716 40 33.5C40 34.3284 39.3284 35 38.5 35H16.5C15.6716 35 15 34.3284 15 33.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 26.5C15 25.6716 15.6716 25 16.5 25H38.5C39.3284 25 40 25.6716 40 26.5C40 27.3284 39.3284 28 38.5 28H16.5C15.6716 28 15 27.3284 15 26.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 19.5C15 18.6716 15.6716 18 16.5 18H38.5C39.3284 18 40 18.6716 40 19.5C40 20.3284 39.3284 21 38.5 21H16.5C15.6716 21 15 20.3284 15 19.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 61C51.5228 61 56 56.5228 56 51C56 45.4772 51.5228 41 46 41C40.4772 41 36 45.4772 36 51C36 56.5228 40.4772 61 46 61ZM46 64C53.1797 64 59 58.1797 59 51C59 43.8203 53.1797 38 46 38C38.8203 38 33 43.8203 33 51C33 58.1797 38.8203 64 46 64Z"
    />
    <circle
      className={`color-iconPrimary-disabled ${pathClass}`}
      cx="46"
      cy="51"
      r="10"
    />
    <g className="animate-spin origin-[46px_51px]">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.608 47.2705C44.3159 47.4063 43.2457 48.1823 42.6803 49.2548C42.4227 49.7433 41.8179 49.9306 41.3293 49.673C40.8408 49.4155 40.6535 48.8106 40.9111 48.3221C41.7745 46.6844 43.4154 45.4899 45.399 45.2815C47.3826 45.073 49.236 45.9002 50.421 47.3225C50.7745 47.7469 50.7171 48.3774 50.2927 48.7309C49.8684 49.0844 49.2379 49.027 48.8844 48.6027C48.1083 47.6712 46.9001 47.1347 45.608 47.2705ZM41.7073 53.269C42.1316 52.9155 42.7622 52.9729 43.1157 53.3972C43.8917 54.3287 45.0999 54.8652 46.392 54.7294C47.6841 54.5936 48.7543 53.8176 49.3197 52.7451C49.5773 52.2566 50.1821 52.0693 50.6707 52.3269C51.1592 52.5844 51.3465 53.1893 51.0889 53.6778C50.2256 55.3155 48.5847 56.51 46.6011 56.7185C44.6174 56.9269 42.764 56.0998 41.5791 54.6774C41.2256 54.253 41.283 53.6225 41.7073 53.269Z"
        className={`color-iconBrand ${pathClass}`}
      />
      <path
        d="M51.2296 49.5787L51.5824 47.0679C51.6444 46.6268 51.1422 46.3309 50.7864 46.599L47.9227 48.757C47.5669 49.025 47.7129 49.5894 48.154 49.6514L50.6648 50.0043C50.9383 50.0427 51.1911 49.8522 51.2296 49.5787Z"
        className={`color-iconBrand ${pathClass}`}
      />
      <path
        d="M40.7703 52.4194L40.4174 54.9303C40.3554 55.3714 40.8577 55.6673 41.2134 55.3992L44.0772 53.2412C44.4329 52.9731 44.287 52.4087 43.8459 52.3467L41.335 51.9939C41.0615 51.9554 40.8087 52.146 40.7703 52.4194Z"
        className={`color-iconBrand ${pathClass}`}
      />
    </g>
  </svg>
)
